// extracted by mini-css-extract-plugin
module.exports = {"DeletePaymentMethod":"PaymentMethodsSettings_DeletePaymentMethod__2UBAG","AddPaymentMethod":"PaymentMethodsSettings_AddPaymentMethod__G982N"};